module.exports = __webpack_public_path__ + "img/price-down-title_1.ce04379e.png";